import React, { Fragment, memo, useEffect } from 'react';
import styled from 'styled-components';
import { Title1, Body } from '../../components/Typography';
import PaymentMethodPreview from './components/PaymentMethodPreview';
import { AddNewPaymentMethodButton } from '../../components/Buttons';
import AddGiftCardButton from '../../components/Buttons/AddGiftCardButton';
import GiftCardContainer from '../GiftCard/giftCardContainer';
import appConfig from '../../../app-config';

const Wrapper = styled.div`
  display: ${(props) => (props.openInModal ? 'block' : 'grid')};
  grid-template-columns: 300px 1fr;
  margin-top: 15px;
  @media screen and (max-width: 768px) {
    display: block;
  }
  @media screen and (max-width: 360px) {
    margin: 0;
  }
`;
const TitleWrapper = styled.div`
  width: max-content;
  font-weight: 600;
  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);
    padding-top: 2px;
    border-bottom: ${(props) => props.categoriesBarSelectedBorderColorWidth}
      solid ${(props) => props.theme.categoriesBarSelectedBorderColor};
  }
`;
const MessageWrapper = styled.div`
  font-family: Inter;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 15px;
  color: #737a87;
`;
const AddPayment = styled.div`
  font-family: Inter, sans-serif;
  font-size: 19px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 15px;
  color: #000000;
  width: 100%;
  text-align: left;
  margin-top: 40px;
`;
const PaymentMethodsWrapper = styled.div`
  padding-top: 20px;
  @media screen and (max-width: 768px) {
    padding-top: 50px;
  }
`;
const NoPaymentOptionTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  margin: 10px 0px;
  height: 44px;
  color: #737a87;
`;
const NoPaymentOption = styled.div`
  width: 383px;
  text-align: center;
  color: ${(props) => props.theme.darkGray};
  i {
    font-size: 40px;
  }
`;
const PaymentButtonWrapper = styled.div`
  width: 383px;
  margin: 15px 0;
`;
const BoldBody = styled(Body)`
  font-weight: 600;
`;
const PaymentMethods = ({
  paymentMethods,
  setDefaultPaymentMethod,
  editStateIsVisible,
  initiateDeletePaymentMethod,
  noDialogBackground,
  showGiftCardModal,
  initiateReloadGiftCard,
  reloadGiftCard,
  isForGiftCard,
  sourceConfig,
  isGiftCardEnabled,
  openInModal,
  defaultPaymentMethod,
  showPaymentMethodSelectionForm,
  isForCheckoutPage,
}) => {
  return (
    <Wrapper openInModal={openInModal}>
      <TitleWrapper id='PaymentMethods-Title'>
        <Title1>Payment Methods </Title1>
      </TitleWrapper>
      <PaymentMethodsWrapper>
        {paymentMethods && paymentMethods.length === 0 && (
          <NoPaymentOption>
            {appConfig.appSource == 'iQ' ? (
              <img
                src='https://cdn.zeplin.io/5eecf39877a3e0469ce04a0d/assets/8583EF70-DC5D-4EA2-88B8-F9B0F333A984.svg'
                width='85'
                style={{ margin: 'auto' }}
              />
            ) : (
              <i
                class='fa fa-credit-card'
                style={{
                  color:
                    appConfig.styleConfig.orderHistoryIconColor ||
                    appConfig.styleConfig.darkGray,
                }}
              ></i>
            )}
            <NoPaymentOptionTitle>No Payment Methods</NoPaymentOptionTitle>
            <MessageWrapper>
              You don’t have any payment methods stored
            </MessageWrapper>
            <AddPayment>Add a Payment Method</AddPayment>
            <PaymentButtonWrapper>
              <AddNewPaymentMethodButton
                noDialogBackground={noDialogBackground}
              />
              {!isForGiftCard && isGiftCardEnabled && (
                <AddGiftCardButton paymentMethods={paymentMethods} />
              )}
              {!isForGiftCard && isGiftCardEnabled && <GiftCardContainer />}
            </PaymentButtonWrapper>
          </NoPaymentOption>
        )}
        {paymentMethods && paymentMethods.length > 0 && (
          <Fragment>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '10px',
              }}
            >
              <BoldBody>My Payment Methods:</BoldBody>
            </div>
            {!isForGiftCard &&
              paymentMethods.map((paymentMethod) => (
                <PaymentMethodPreview
                  key={paymentMethod.id}
                  paymentMethod={paymentMethod}
                  setDefaultPaymentMethod={setDefaultPaymentMethod}
                  editStateIsVisible={editStateIsVisible}
                  initiateDeletePaymentMethod={initiateDeletePaymentMethod}
                  showGiftCardModal={showGiftCardModal}
                  initiateReloadGiftCard={initiateReloadGiftCard}
                  reloadGiftCard={reloadGiftCard}
                  sourceConfig={sourceConfig}
                  isForGiftCard={isForGiftCard}
                  isForCheckoutPage={isForCheckoutPage}
                  showPaymentMethodSelectionForm={
                    showPaymentMethodSelectionForm
                  }
                />
              ))}
            {isForGiftCard &&
              paymentMethods
                .filter((method) => method.type != 'gift_card')
                .map((paymentMethod) => (
                  <PaymentMethodPreview
                    key={paymentMethod.id}
                    paymentMethod={paymentMethod}
                    setDefaultPaymentMethod={setDefaultPaymentMethod}
                    editStateIsVisible={editStateIsVisible}
                    initiateDeletePaymentMethod={initiateDeletePaymentMethod}
                    showGiftCardModal={showGiftCardModal}
                    initiateReloadGiftCard={initiateReloadGiftCard}
                    reloadGiftCard={reloadGiftCard}
                    sourceConfig={sourceConfig}
                    isForGiftCard={isForGiftCard}
                    isForCheckoutPage={isForCheckoutPage}
                    showPaymentMethodSelectionForm={
                      showPaymentMethodSelectionForm
                    }
                  />
                ))}

            <PaymentButtonWrapper>
              {!isForGiftCard && isGiftCardEnabled && (
                <AddGiftCardButton paymentMethods={paymentMethods} />
              )}
              {!isForGiftCard && isGiftCardEnabled && <GiftCardContainer />}
            </PaymentButtonWrapper>
            <PaymentButtonWrapper>
              <AddNewPaymentMethodButton
                noDialogBackground={noDialogBackground}
              />
            </PaymentButtonWrapper>
          </Fragment>
        )}
        {/* <AddNewPaymentMethodButton noDialogBackground={noDialogBackground} /> */}
      </PaymentMethodsWrapper>
    </Wrapper>
  );
};

export default memo(PaymentMethods);
